//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AppHero',
  props: ["query", "setQuery", "executeSearch",],
  data() {
    return {}
  },
  computed: {
    model: {
      get() {
        return this.query;
      },
      set(value) {
        this.setQuery(value);
      }
    }
  },
  methods: {
    clearSearch() {
      this.setQuery('');
      this.executeSearch();
    }
  }
}
